import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

/** Catches render errors so a failure shows a message instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Render error:', error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="wrap">
          <div className="empty">
            <h3>Something went wrong</h3>
            <p>{this.state.error.message}</p>
            <button className="btn btn-primary" onClick={() => window.location.assign('/')}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
